export abstract class ForgotPasswordBase {
  constructor(public email?: string) {}

  public toRequest() {
    return { email: this.email };
  }
}
